__turbopack_context__.v({
  "highlight": "ComparisonChartTable-module__bFTtjq__highlight",
  "scroller": "ComparisonChartTable-module__bFTtjq__scroller",
});
